import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const translations = {
  nl: {
    // Navigation
    nav: {
      home: 'Home',
      properties: 'Woningen',
      costaBlanca: 'Costa Blanca',
      costaCalida: 'Costa Calida',
      costaAlmeria: 'Costa Almeria',
      invest: 'Investeren',
      blog: 'Kennisbank',
      contact: 'Contact',
    },
    // Home page
    home: {
      heroTitle: 'Exclusieve woningen in Spanje',
      heroSubtitle: 'Ontdek zorgvuldig geselecteerde woningen in Costa Blanca, Costa Calida en Costa Almeria',
      viewProperties: 'Bekijk woningen',
      discoverOffer: 'Ontdek aanbod',
      searchOnMap: 'Zoek op kaart',
      uspSelection: 'Geselecteerd aanbod',
      uspSelectionText: 'Toegang tot duizenden woningen via ons netwerk van erkende makelaars aan de Spaanse kust.',
      uspExpertise: 'Lokale expertise',
      uspExpertiseText: 'Samen met lokale makelaars, financieel adviseurs en juridische specialisten begeleiden wij kopers van begin tot eind.',
      uspInvestment: 'Investering & Rendement',
      uspInvestmentText: 'Van vakantiewoning tot vastgoedbelegging: wij brengen u in contact met de juiste specialisten voor een zorgeloze aankoop.',
      featuredProperties: 'Uitgelichte woningen',
      featuredSubtitle: 'Onze topselectie voor deze maand',
      viewAllProperties: 'Bekijk alle woningen',
      discoverRegions: 'Ontdek de regio\'s',
      regionsSubtitle: 'Van Costa Blanca tot Costa Almeria',
      costaBlancaSubtitle: 'Het witte paradijs',
      costaCalidaSubtitle: 'De warme kust van Murcia',
      costaAlmeriaSubtitle: 'Ongerepte schoonheid',
    },
    // Properties page
    properties: {
      title: 'Ons aanbod',
      subtitle: 'Ontdek alle beschikbare woningen',
      filters: 'Filters',
      region: 'Regio',
      allRegions: 'Alle regio\'s',
      propertyType: 'Type woning',
      allTypes: 'Alle types',
      priceRange: 'Prijsklasse',
      allPrices: 'Alle prijzen',
      upTo: 'Tot',
      andAbove: 'en hoger',
      sortBy: 'Sorteren',
      priceHighLow: 'Prijs: Hoog - Laag',
      priceLowHigh: 'Prijs: Laag - Hoog',
      bedroomsMost: 'Slaapkamers: Meest',
      surfaceLargest: 'Oppervlakte: Grootst',
      propertiesFound: 'woningen gevonden',
      propertyFound: 'woning gevonden',
      noProperties: 'Geen woningen gevonden met de geselecteerde filters.',
      resetFilters: 'Reset filters',
      loading: 'Laden...',
      searchPlaceholder: 'Zoek op locatie...',
    },
    // Property card
    property: {
      viewProperty: 'Bekijk woning',
      featured: 'Uitgelicht',
      newBuild: 'Nieuwbouw',
      photos: "foto's",
      bedrooms: 'Slaapkamers',
      bathrooms: 'Badkamers',
      surface: 'Oppervlakte',
      redirectNote: 'U wordt doorgestuurd naar onze partner voor meer details',
      description: 'Omschrijving',
      features: 'Kenmerken',
      backToProperties: 'Terug naar woningen',
    },
    // Regions
    regions: {
      costaBlanca: {
        title: 'Costa Blanca',
        subtitle: 'Het witte paradijs van Spanje',
        intro: 'De Costa Blanca staat bekend om zijn prachtige witte stranden, kristalhelder water en meer dan 300 dagen zon per jaar. Deze regio biedt een perfecte mix van authentiek Spaans leven en moderne voorzieningen.',
        benefit1: '300+ dagen zon',
        benefit1Text: 'Geniet het hele jaar door van prachtig weer',
        benefit2: 'Sterke waardestijging',
        benefit2Text: 'Uitstekend investeringsklimaat',
        benefit3: 'Internationale gemeenschap',
        benefit3Text: 'Veel Nederlandse en Belgische bewoners',
      },
      costaCalida: {
        title: 'Costa Calida',
        subtitle: 'De warme kust van Murcia',
        intro: 'De Costa Calida, oftewel de \'Warme Kust\', ligt in de regio Murcia en staat bekend om zijn aangename klimaat met meer dan 320 dagen zon per jaar. Populaire plaatsen zijn onder andere Los Alcázares en de Mar Menor.',
        benefit1: '320+ dagen zon',
        benefit1Text: 'Een van de warmste klimaten van Europa',
        benefit2: 'Mar Menor',
        benefit2Text: 'Europa\'s grootste zoutwatermeer voor watersport',
        benefit3: 'Betaalbaar',
        benefit3Text: 'Uitstekende prijs-kwaliteitverhouding',
      },
      costaAlmeria: {
        title: 'Costa Almeria',
        subtitle: 'Ongerepte schoonheid en authentiek Spanje',
        intro: 'De Costa de Almería is een van de laatste ongerepte kustgebieden van Spanje. Het Cabo de Gata-Níjar natuurpark biedt spectaculaire kliffen en kristalhelder water.',
        benefit1: 'Uniek landschap',
        benefit1Text: 'Woestijn, bergen en kristalheldere zee',
        benefit2: 'Ongerept natuurschoon',
        benefit2Text: 'Cabo de Gata natuurpark aan uw deur',
        benefit3: 'Verborgen parel',
        benefit3Text: 'Opkomende markt met groeipotentieel',
      },
      propertiesIn: 'Woningen in',
      noPropertiesRegion: 'Momenteel geen woningen beschikbaar in deze regio.',
    },
    // Invest page
    invest: {
      title: 'Investeren in Spanje',
      subtitle: 'Rendement, waardestijging en verhuurpotentieel',
      intro: 'Vastgoed in Spanje biedt uitstekende investeringsmogelijkheden. Met een groeiende toeristische sector en aantrekkelijke prijzen, is nu een ideaal moment om te investeren.',
      whyInvest: 'Waarom investeren in Spanje?',
      benefit1: 'Sterke waardestijging',
      benefit1Text: 'Vastgoedprijzen stijgen gemiddeld 5-8% per jaar',
      benefit2: 'Verhuurrendement 6-10%',
      benefit2Text: 'Door sterke vraag naar vakantieverhuur',
      benefit3: 'Eigen gebruik',
      benefit3Text: 'Geniet zelf van uw woning tijdens vakanties',
      benefit4: 'Sterke vraag',
      benefit4Text: 'Spanje blijft een topbestemming voor toeristen en expats',
      example: 'Rekenvoorbeeld',
      purchasePrice: 'Aankoopprijs',
      annualRental: 'Jaarlijkse huurinkomsten',
      grossYield: 'Bruto rendement',
      appreciation: 'Waardestijging (gem. 6%/jaar)',
      totalReturn: 'Totaal rendement jaar 1',
      readyToInvest: 'Klaar om te investeren?',
      viewInvestmentProperties: 'Bekijk investeringsobjecten',
    },
    // Blog
    blog: {
      title: 'Blog',
      subtitle: 'Tips, trends en inspiratie over wonen in Spanje',
      readMore: 'Lees meer',
      backToBlog: 'Terug naar blog',
      noPosts: 'Nog geen blogartikelen beschikbaar.',
      readyToFind: 'Klaar om uw droomwoning te vinden?',
    },
    // Contact
    contact: {
      title: 'Contact',
      subtitle: 'Vragen? Neem gerust contact op',
      intro: 'Bij CasaOthers staan we altijd klaar om uw vragen te beantwoorden. De snelste manier om contact met ons op te nemen is via WhatsApp.',
      whatsappContact: 'WhatsApp Contact',
      whatsappText: 'Stuur ons een bericht en we reageren zo snel mogelijk',
      startChat: 'Start WhatsApp gesprek',
      helpWith: 'Waar kunnen we u mee helpen?',
      help1: 'Informatie over specifieke woningen',
      help2: 'Advies over investeren in Spanje',
      help3: 'Vragen over de regio\'s',
      help4: 'Algemene vragen over het aankoopproces',
    },
    // Footer
    footer: {
      tagline: 'Uw partner voor exclusieve woningen in Spanje',
      navigation: 'Navigatie',
      regions: 'Regio\'s',
      contact: 'Contact',
      questionsWhatsApp: 'Vragen? Neem contact op via WhatsApp',
      whatsapp: 'WhatsApp',
      allRights: 'Alle rechten voorbehouden.',
    },
    // Common
    common: {
      loading: 'Laden...',
      villa: 'Villa',
      apartment: 'Appartement',
      penthouse: 'Penthouse',
      townhouse: 'Townhouse',
    },
    // SEO
    seo: {
      homeTitle: 'Exclusieve woningen in Spanje',
      homeDescription: 'Ontdek zorgvuldig geselecteerde luxe woningen aan de Costa Blanca, Costa Calida en Costa Almeria. Uw premium partner voor wonen en investeren in Spanje.',
      propertiesTitle: 'Ons woningaanbod',
      propertiesDescription: 'Bekijk alle beschikbare luxe woningen in Spanje. Villa\'s, appartementen en penthouses op de mooiste locaties aan de Spaanse zonnekust.',
      costaBlancaTitle: 'Costa Blanca – Woningen',
      costaBlancaDescription: 'Ontdek exclusieve woningen aan de Costa Blanca. 300+ dagen zon per jaar, witte stranden en een sterke Nederlandse en Belgische gemeenschap.',
      costaCalidaTitle: 'Costa Calida – Woningen',
      costaCalidaDescription: 'Woningen aan de Costa Calida, de warme kust van Murcia. 320+ dagen zon, betaalbaar en met de prachtige Mar Menor vlakbij.',
      costaAlmeriaTitle: 'Costa Almeria – Woningen',
      costaAlmeriaDescription: 'Woningen aan de ongerepte Costa Almeria. Cabo de Gata natuurpark, authentiek Spanje en een opkomende vastgoedmarkt met groeipotentieel.',
      investTitle: 'Investeren in Spaans vastgoed',
      investDescription: 'Investeer in Spaans vastgoed met 6-10% verhuurrendement en een gemiddelde waardestijging van 5-8% per jaar. Ontdek onze investeringswoningen.',
      blogTitle: 'Kennisbank — wonen en investeren in Spanje',
      blogDescription: 'Praktische kennis, inzichten en inspiratie over wonen, kopen en investeren in Spanje. Van Costa Blanca tot Costa Almeria.',
      contactTitle: 'Contact',
      contactDescription: 'Vragen over wonen in Spanje? Neem direct contact met ons op via WhatsApp voor snel en persoonlijk advies.',
    },
  },
  en: {
    // Navigation
    nav: {
      home: 'Home',
      properties: 'Properties',
      costaBlanca: 'Costa Blanca',
      costaCalida: 'Costa Calida',
      costaAlmeria: 'Costa Almeria',
      invest: 'Invest',
      blog: 'Knowledge Base',
      contact: 'Contact',
    },
    // Home page
    home: {
      heroTitle: 'Exclusive Properties in Spain',
      heroSubtitle: 'Discover carefully selected properties in Costa Blanca, Costa Calida and Costa Almeria',
      viewProperties: 'View Properties',
      discoverOffer: 'Discover Listings',
      searchOnMap: 'Search on map',
      uspSelection: 'Curated Selection',
      uspSelectionText: 'Access to thousands of properties through our network of recognised real estate agents along the Spanish coast.',
      uspExpertise: 'Local expertise',
      uspExpertiseText: 'Together with local agents, financial advisors and legal specialists, we guide buyers from start to finish.',
      uspInvestment: 'Investment & Returns',
      uspInvestmentText: 'From holiday home to property investment: we connect you with the right specialists for a worry-free purchase.',
      featuredProperties: 'Featured Properties',
      featuredSubtitle: 'Our top selection for this month',
      viewAllProperties: 'View All Properties',
      discoverRegions: 'Discover the Regions',
      regionsSubtitle: 'From Costa Blanca to Costa Almeria',
      costaBlancaSubtitle: 'The white paradise',
      costaCalidaSubtitle: 'The warm coast of Murcia',
      costaAlmeriaSubtitle: 'Unspoiled beauty',
    },
    // Properties page
    properties: {
      title: 'Our Listings',
      subtitle: 'Discover all available properties',
      filters: 'Filters',
      region: 'Region',
      allRegions: 'All regions',
      propertyType: 'Property Type',
      allTypes: 'All types',
      priceRange: 'Price Range',
      allPrices: 'All prices',
      upTo: 'Up to',
      andAbove: 'and above',
      sortBy: 'Sort by',
      priceHighLow: 'Price: High - Low',
      priceLowHigh: 'Price: Low - High',
      bedroomsMost: 'Bedrooms: Most',
      surfaceLargest: 'Surface: Largest',
      propertiesFound: 'properties found',
      propertyFound: 'property found',
      noProperties: 'No properties found with selected filters.',
      resetFilters: 'Reset filters',
      loading: 'Loading...',
      searchPlaceholder: 'Search by location...',
    },
    // Property card
    property: {
      viewProperty: 'View Property',
      featured: 'Featured',
      newBuild: 'New build',
      photos: 'photos',
      bedrooms: 'Bedrooms',
      bathrooms: 'Bathrooms',
      surface: 'Surface',
      redirectNote: 'You will be redirected to our partner for more details',
      description: 'Description',
      features: 'Features',
      backToProperties: 'Back to properties',
    },
    // Regions
    regions: {
      costaBlanca: {
        title: 'Costa Blanca',
        subtitle: 'The white paradise of Spain',
        intro: 'Costa Blanca is known for its beautiful white beaches, crystal clear water and more than 300 days of sunshine per year. This region offers a perfect mix of authentic Spanish life and modern amenities.',
        benefit1: '300+ days of sun',
        benefit1Text: 'Enjoy beautiful weather all year round',
        benefit2: 'Strong appreciation',
        benefit2Text: 'Excellent investment climate',
        benefit3: 'International community',
        benefit3Text: 'Many Dutch and Belgian residents',
      },
      costaCalida: {
        title: 'Costa Calida',
        subtitle: 'The warm coast of Murcia',
        intro: 'Costa Calida, the \'Warm Coast\', is located in the Murcia region and is known for its pleasant climate with more than 320 days of sunshine per year. Popular places include Los Alcázares and Mar Menor.',
        benefit1: '320+ days of sun',
        benefit1Text: 'One of the warmest climates in Europe',
        benefit2: 'Mar Menor',
        benefit2Text: 'Europe\'s largest saltwater lake for water sports',
        benefit3: 'Affordable',
        benefit3Text: 'Excellent value for money',
      },
      costaAlmeria: {
        title: 'Costa Almeria',
        subtitle: 'Unspoiled beauty and authentic Spain',
        intro: 'Costa de Almería is one of the last unspoiled coastal areas in Spain. Cabo de Gata-Níjar Natural Park offers spectacular cliffs and crystal clear water.',
        benefit1: 'Unique landscape',
        benefit1Text: 'Desert, mountains and crystal clear sea',
        benefit2: 'Pristine nature',
        benefit2Text: 'Cabo de Gata natural park at your doorstep',
        benefit3: 'Hidden gem',
        benefit3Text: 'Emerging market with growth potential',
      },
      propertiesIn: 'Properties in',
      noPropertiesRegion: 'Currently no properties available in this region.',
    },
    // Invest page
    invest: {
      title: 'Invest in Spain',
      subtitle: 'Returns, appreciation and rental potential',
      intro: 'Real estate in Spain offers excellent investment opportunities. With a growing tourism sector and attractive prices, now is an ideal time to invest.',
      whyInvest: 'Why invest in Spain?',
      benefit1: 'Strong appreciation',
      benefit1Text: 'Property prices rise an average of 5-8% per year',
      benefit2: 'Rental yield 6-10%',
      benefit2Text: 'Due to strong demand for vacation rentals',
      benefit3: 'Personal use',
      benefit3Text: 'Enjoy your property during your own vacations',
      benefit4: 'Strong demand',
      benefit4Text: 'Spain remains a top destination for tourists and expats',
      example: 'Example calculation',
      purchasePrice: 'Purchase price',
      annualRental: 'Annual rental income',
      grossYield: 'Gross yield',
      appreciation: 'Appreciation (avg. 6%/year)',
      totalReturn: 'Total return year 1',
      readyToInvest: 'Ready to invest?',
      viewInvestmentProperties: 'View investment properties',
    },
    // Knowledge Base — URL segments stay "/blog" for SEO continuity
    blog: {
      title: 'Knowledge Base',
      subtitle: 'Practical knowledge, insights and inspiration about living, buying and investing in Spain',
      readMore: 'Read more',
      backToBlog: 'Back to knowledge base',
      noPosts: 'No articles available yet.',
      readyToFind: 'Ready to find your dream home?',
    },
    // Contact
    contact: {
      title: 'Contact',
      subtitle: 'Questions? Feel free to reach out',
      intro: 'At CasaOthers we are always ready to answer your questions. The fastest way to contact us is via WhatsApp.',
      whatsappContact: 'WhatsApp Contact',
      whatsappText: 'Send us a message and we\'ll respond as soon as possible',
      startChat: 'Start WhatsApp chat',
      helpWith: 'How can we help you?',
      help1: 'Information about specific properties',
      help2: 'Advice on investing in Spain',
      help3: 'Questions about the regions',
      help4: 'General questions about the purchase process',
    },
    // Footer
    footer: {
      tagline: 'Your partner for exclusive properties in Spain',
      navigation: 'Navigation',
      regions: 'Regions',
      contact: 'Contact',
      questionsWhatsApp: 'Questions? Contact us via WhatsApp',
      whatsapp: 'WhatsApp',
      allRights: 'All rights reserved.',
    },
    // Common
    common: {
      loading: 'Loading...',
      villa: 'Villa',
      apartment: 'Apartment',
      penthouse: 'Penthouse',
      townhouse: 'Townhouse',
    },
    // SEO
    seo: {
      homeTitle: 'Exclusive properties in Spain',
      homeDescription: 'Discover carefully curated luxury properties on the Costa Blanca, Costa Calida and Costa Almeria. Your premium partner for living and investing in Spain.',
      propertiesTitle: 'Our property listings',
      propertiesDescription: 'Browse all available luxury properties in Spain. Villas, apartments and penthouses in the most beautiful locations on the Spanish sunshine coast.',
      costaBlancaTitle: 'Costa Blanca – Properties',
      costaBlancaDescription: 'Discover exclusive properties on the Costa Blanca. 300+ days of sunshine per year, white beaches and a strong international community.',
      costaCalidaTitle: 'Costa Calida – Properties',
      costaCalidaDescription: 'Properties on the Costa Calida, the warm coast of Murcia. 320+ days of sun, affordable prices and the beautiful Mar Menor nearby.',
      costaAlmeriaTitle: 'Costa Almeria – Properties',
      costaAlmeriaDescription: 'Properties on the unspoiled Costa Almeria. Cabo de Gata natural park, authentic Spain and an emerging real estate market with growth potential.',
      investTitle: 'Invest in Spanish real estate',
      investDescription: 'Invest in Spanish real estate with 6-10% rental yield and an average appreciation of 5-8% per year. Discover our investment properties.',
      blogTitle: 'Knowledge Base — living and investing in Spain',
      blogDescription: 'Practical knowledge, insights and inspiration about living, buying and investing in Spain. From Costa Blanca to Costa Almeria.',
      contactTitle: 'Contact',
      contactDescription: 'Questions about living in Spain? Contact us directly via WhatsApp for fast and personal advice.',
    },
  },
  pl: {
      nav: {
        home: 'Start',
        properties: 'Nieruchomości',
        costaBlanca: 'Costa Blanca',
        costaCalida: 'Costa Calida',
        costaAlmeria: 'Costa Almeria',
        invest: 'Inwestycje',
        blog: 'Baza wiedzy',
        contact: 'Kontakt'
      },
      home: {
        heroTitle: 'Ekskluzywne nieruchomości w Hiszpanii',
        heroSubtitle: 'Odkryj starannie wyselekcjonowane nieruchomości na Costa Blanca, Costa Calida i Costa Almeria',
        viewProperties: 'Zobacz nieruchomości',
        discoverOffer: 'Odkryj ofertę',
        searchOnMap: 'Szukaj na mapie',
        uspSelection: 'Wyselekcjonowana oferta',
        uspSelectionText: 'Dostęp do tysięcy nieruchomości poprzez naszą sieć uznanych agencji nieruchomości na hiszpańskim wybrzeżu.',
        uspExpertise: 'Lokalna ekspertyza',
        uspExpertiseText: 'Wspólnie z lokalnymi agentami, doradcami finansowymi i specjalistami prawnymi wspieramy nabywców od początku do końca.',
        uspInvestment: 'Inwestycja i zwrot',
        uspInvestmentText: 'Od domu wakacyjnego po inwestycję w nieruchomości: łączymy Państwa z odpowiednimi specjalistami dla bezproblemowego zakupu.',
        featuredProperties: 'Wyróżnione nieruchomości',
        featuredSubtitle: 'Nasz najlepszy wybór na ten miesiąc',
        viewAllProperties: 'Zobacz wszystkie nieruchomości',
        discoverRegions: 'Odkryj regiony',
        regionsSubtitle: 'Od Costa Blanca po Costa Almeria',
        costaBlancaSubtitle: 'Biały raj',
        costaCalidaSubtitle: 'Ciepłe wybrzeże Murcji',
        costaAlmeriaSubtitle: 'Dziewicze piękno'
      },
      properties: {
        title: 'Nasza oferta',
        subtitle: 'Odkryj wszystkie dostępne nieruchomości',
        filters: 'Filtry',
        region: 'Region',
        allRegions: 'Wszystkie regiony',
        propertyType: 'Typ nieruchomości',
        allTypes: 'Wszystkie typy',
        priceRange: 'Przedział cenowy',
        allPrices: 'Wszystkie ceny',
        upTo: 'Do',
        andAbove: 'i więcej',
        sortBy: 'Sortuj',
        priceHighLow: 'Cena: Od najwyższej',
        priceLowHigh: 'Cena: Od najniższej',
        bedroomsMost: 'Sypialnie: Najwięcej',
        surfaceLargest: 'Powierzchnia: Największa',
        propertiesFound: 'znalezionych nieruchomości',
        propertyFound: 'znaleziona nieruchomość',
        noProperties: 'Nie znaleziono nieruchomości spełniających wybrane kryteria.',
        resetFilters: 'Resetuj filtry',
        loading: 'Ładowanie...',
        searchPlaceholder: 'Szukaj według lokalizacji...'
      },
      property: {
        viewProperty: 'Zobacz nieruchomość',
        featured: 'Wyróżnione',
      newBuild: 'Nowe budownictwo',
      photos: 'zdjęć',
        bedrooms: 'Sypialnie',
        bathrooms: 'Łazienki',
        surface: 'Powierzchnia',
        redirectNote: 'Zostaniesz przekierowany do naszego partnera w celu uzyskania szczegółowych informacji',
        description: 'Opis',
        features: 'Cechy',
        backToProperties: 'Powrót do nieruchomości'
      },
      regions: {
        costaBlanca: {
          title: 'Costa Blanca',
          subtitle: 'Biały raj Hiszpanii',
          intro: 'Costa Blanca słynie z przepięknych białych plaż, krystalicznie czystej wody i ponad 300 słonecznych dni w roku. Region oferuje idealne połączenie autentycznego hiszpańskiego życia i nowoczesnej infrastruktury.',
          benefit1: '300+ dni słońca',
          benefit1Text: 'Ciesz się wspaniałą pogodą przez cały rok',
          benefit2: 'Silny wzrost wartości',
          benefit2Text: 'Doskonały klimat inwestycyjny',
          benefit3: 'Międzynarodowa społeczność',
          benefit3Text: 'Wielu holenderskich i belgijskich mieszkańców'
        },
        costaCalida: {
          title: 'Costa Calida',
          subtitle: 'Ciepłe wybrzeże Murcji',
          intro: 'Costa Calida, czyli \'Ciepłe Wybrzeże\', położone w regionie Murcji, słynie z przyjemnego klimatu z ponad 320 słonecznymi dniami w roku. Do popularnych miejscowości należą Los Alcázares i Mar Menor.',
          benefit1: '320+ dni słońca',
          benefit1Text: 'Jeden z najcieplejszych klimatów w Europie',
          benefit2: 'Mar Menor',
          benefit2Text: 'Największa słona laguna w Europie do sportów wodnych',
          benefit3: 'Przystępne ceny',
          benefit3Text: 'Doskonały stosunek jakości do ceny'
        },
        costaAlmeria: {
          title: 'Costa Almeria',
          subtitle: 'Dziewicze piękno i autentyczna Hiszpania',
          intro: 'Costa de Almería to jeden z ostatnich nietkniętych obszarów wybrzeża w Hiszpanii. Park przyrody Cabo de Gata-Níjar oferuje spektakularne klify i krystalicznie czystą wodę.',
          benefit1: 'Wyjątkowy krajobraz',
          benefit1Text: 'Pustynia, góry i krystaliczne morze',
          benefit2: 'Dziewicze piękno przyrody',
          benefit2Text: 'Park przyrody Cabo de Gata tuż obok',
          benefit3: 'Ukryta perła',
          benefit3Text: 'Rozwijający się rynek z potencjałem wzrostu'
        },
        propertiesIn: 'Nieruchomości w',
        noPropertiesRegion: 'Obecnie brak dostępnych nieruchomości w tym regionie.'
      },
      invest: {
        title: 'Inwestycje w Hiszpanii',
        subtitle: 'Zwrot z inwestycji, wzrost wartości i potencjał wynajmu',
        intro: 'Nieruchomości w Hiszpanii oferują doskonałe możliwości inwestycyjne. Dzięki rozwijającemu się sektorowi turystycznemu i atrakcyjnym cenom, teraz jest idealny moment na inwestycję.',
        whyInvest: 'Dlaczego inwestować w Hiszpanii?',
        benefit1: 'Silny wzrost wartości',
        benefit1Text: 'Ceny nieruchomości rosną średnio o 5-8% rocznie',
        benefit2: 'Zwrot z wynajmu 6-10%',
        benefit2Text: 'Dzięki wysokiemu zapotrzebowaniu na wynajem wakacyjny',
        benefit3: 'Własne użytkowanie',
        benefit3Text: 'Ciesz się własną nieruchomością podczas wakacji',
        benefit4: 'Wysokie zapotrzebowanie',
        benefit4Text: 'Hiszpania pozostaje topową destynacją dla turystów i ekspatów',
        example: 'Przykład kalkulacji',
        purchasePrice: 'Cena zakupu',
        annualRental: 'Roczne przychody z wynajmu',
        grossYield: 'Zwrot brutto',
        appreciation: 'Wzrost wartości (śr. 6%/rok)',
        totalReturn: 'Całkowity zwrot rok 1',
        readyToInvest: 'Gotowy do inwestycji?',
        viewInvestmentProperties: 'Zobacz nieruchomości inwestycyjne'
      },
      blog: {
        title: 'Blog',
        subtitle: 'Porady, trendy i inspiracje dotyczące życia w Hiszpanii',
        readMore: 'Czytaj więcej',
        backToBlog: 'Powrót do bloga',
        noPosts: 'Jeszcze brak dostępnych artykułów.',
        readyToFind: 'Gotowy znaleźć wymarzoną nieruchomość?'
      },
      contact: {
        title: 'Kontakt',
        subtitle: 'Pytania? Skontaktuj się z nami',
        intro: 'W CasaOthers zawsze jesteśmy gotowi odpowiedzieć na Państwa pytania. Najszybszym sposobem kontaktu jest WhatsApp.',
        whatsappContact: 'Kontakt przez WhatsApp',
        whatsappText: 'Wyślij nam wiadomość, a odpowiemy najszybciej jak to możliwe',
        startChat: 'Rozpocznij rozmowę przez WhatsApp',
        helpWith: 'W czym możemy pomóc?',
        help1: 'Informacje o konkretnych nieruchomościach',
        help2: 'Porady dotyczące inwestowania w Hiszpanii',
        help3: 'Pytania o regiony',
        help4: 'Ogólne pytania dotyczące procesu zakupu'
      },
      footer: {
        tagline: 'Twój partner w ekskluzywnych nieruchomościach w Hiszpanii',
        navigation: 'Nawigacja',
        regions: 'Regiony',
        contact: 'Kontakt',
        questionsWhatsApp: 'Pytania? Skontaktuj się przez WhatsApp',
        whatsapp: 'WhatsApp',
        allRights: 'Wszelkie prawa zastrzeżone.'
      },
      common: {
        loading: 'Ładowanie...',
        villa: 'Willa',
        apartment: 'Apartament',
        penthouse: 'Penthouse',
        townhouse: 'Townhouse'
      },
      seo: {
        homeTitle: 'Ekskluzywne nieruchomości w Hiszpanii',
        homeDescription: 'Odkryj starannie wyselekcjonowane luksusowe nieruchomości na Costa Blanca, Costa Calida i Costa Almeria. Twój ekskluzywny partner w zakresie życia i inwestowania w Hiszpanii.',
        propertiesTitle: 'Nasza oferta nieruchomości',
        propertiesDescription: 'Zobacz wszystkie dostępne luksusowe nieruchomości w Hiszpanii. Wille, apartamenty i penthousy w najpiękniejszych lokalizacjach na słonecznym wybrzeżu Hiszpanii.',
        costaBlancaTitle: 'Costa Blanca – Nieruchomości',
        costaBlancaDescription: 'Odkryj ekskluzywne nieruchomości na Costa Blanca. 300+ słonecznych dni w roku, białe plaże i silna holenderska i belgijska społeczność.',
        costaCalidaTitle: 'Costa Calida – Nieruchomości',
        costaCalidaDescription: 'Nieruchomości na Costa Calida, ciepłym wybrzeżu Murcji. 320+ słonecznych dni, przystępne ceny i piękny Mar Menor w pobliżu.',
        costaAlmeriaTitle: 'Costa Almeria – Nieruchomości',
        costaAlmeriaDescription: 'Nieruchomości na dziewiczej Costa Almeria. Park przyrody Cabo de Gata, autentyczna Hiszpania i rozwijający się rynek nieruchomości z potencjałem wzrostu.',
        investTitle: 'Inwestycje w hiszpańskie nieruchomości',
        investDescription: 'Inwestuj w hiszpańskie nieruchomości z 6-10% zwrotem z wynajmu i średnim wzrostem wartości 5-8% rocznie. Odkryj nasze nieruchomości inwestycyjne.',
        blogTitle: 'Baza wiedzy — życie i inwestowanie w Hiszpanii',
        blogDescription: 'Praktyczna wiedza, spostrzeżenia i inspiracje dotyczące życia, kupowania i inwestowania w Hiszpanii. Od Costa Blanca po Costa Almeria.',
        contactTitle: 'Kontakt',
        contactDescription: 'Pytania o życie w Hiszpanii? Skontaktuj się z nami bezpośrednio przez WhatsApp, aby otrzymać szybką i osobistą poradę.'
      }
  },
};

export const LanguageProvider = ({ children }) => {
  // Polish deployment (casaothers.pl): Polish is the only language.
  const [language] = useState('pl');

  const switchLanguage = () => {};

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  return (
    <LanguageContext.Provider value={{ language, switchLanguage, t, translations: translations[language] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
